import React, { useMemo } from 'react';
import { default as D3Tree } from 'react-d3-tree';

import Node from './Node';
import styles from './styles.module.scss';
import { Node as NodeType } from './types';
import { convertToD3TreeFormat } from './utils';

const Tree = ({ node, query }: { node: NodeType; query: string }) => {
  const treeData = useMemo(() => convertToD3TreeFormat(node), [node]);

  return (
    <div className={styles.Tree}>
      <D3Tree
        data={treeData}
        orientation="vertical"
        renderCustomNodeElement={rd3tProps => (
          <Node query={query} {...rd3tProps} />
        )}
        translate={{
          x: window.innerWidth / 2 + 75,
          y: window.innerHeight / 2 - 240,
        }}
        nodeSize={{ x: 300, y: 240 }}
        separation={{ siblings: 2, nonSiblings: 2 }}
        pathFunc="straight"
        zoomable
        zoom={0.25}
      />
    </div>
  );
};

export default Tree;
